import React, { useState } from "react";
import { Button } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CloseIcon from "@mui/icons-material/Close";
import { doc, deleteDoc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { getStorage, ref, deleteObject } from "firebase/storage";

function DeleteNote(props) {
  // ALL STATES
  const [isLoading, setIsLoading] = useState(false);

  const getStorageRefFromUrl = (url = "") => {
    try {
      const storage = getStorage();
      const path = decodeURIComponent(url.split("/o/")[1].split("?")[0]);
      return ref(storage, path);
    } catch (e) {
      console.warn("Failed to build storage ref from url:", url, e);
      return null;
    }
  };

  async function handleDeleteNote() {
    setIsLoading(true);
    try {
      const noteRef = doc(db, "notes", props.noteId);
      const snap = await getDoc(noteRef);
      const files = snap.exists() ? snap.data()?.fileUrls || [] : [];

      // Best-effort deletion of attached files
      await Promise.all(
        files.map(async (f) => {
          const r = getStorageRefFromUrl(f.url);
          if (!r) return;
          try {
            await deleteObject(r);
          } catch (e) {
            console.warn("Failed to delete attachment:", f?.name || f?.url, e);
          }
        })
      );

      await deleteDoc(noteRef);

      toast.success("Note successfully deleted!", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setIsLoading(false);
      props.closemodal();
    } catch (error) {
      console.error("Error deleting note:", error);
      toast.error("Error deleting note", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setIsLoading(false);
    }
  }

  //FUNCTIONS

  return (
    <>
      <div className="inputAndLabelModalContainerTitle2">
        <div className="line1-modal-red">
          <div className="modal-title">
            Delete Note{" "}
            {/* <span style={{ fontSize: "10px" }}>(ID note : {props.noteId})</span> */}
            {/* <span style={{ fontSize: "10px" }}>(note Id: {props.noteId})</span> */}
          </div>

          <CloseIcon
            style={{
              marginRight: "16px",
              color: "rgb(214, 213, 213)",
              cursor: "pointer",
            }}
            onClick={props.closemodal}
          />
        </div>
        <div className="line2-column-modal">
          <div className="confirmation-delete">
            Are you sure you want to delete this note ?
          </div>
        </div>
      </div>

      <div className="line4-modal">
        <>
          <Button
            variant="contained"
            style={{ backgroundColor: "white", color: "black" }}
            // disabled={!(pic1Url && pic2Url && pic3Url && pic4Url && pic5Url)}
            onClick={props.closemodal}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            style={
              isLoading
                ? {
                    backgroundColor: "red",
                    color: "white",
                    marginLeft: "15px",
                  }
                : {
                    backgroundColor: "red",
                    color: "white",
                    marginLeft: "15px",
                  }
            }
            disabled={isLoading}
            onClick={handleDeleteNote}
          >
            {isLoading ? "DELETING NOTE..." : "DELETE NOTES"}
          </Button>
        </>
      </div>
    </>
  );
}

export default DeleteNote;
